import KendoChartBase from '../KendoChartBase'
import StockChartProps from './StockChartProps'
import AxisDefaults from '../KendoChartBase/AxisDefaults'
import CategoryAxis from '../KendoChartBase/CategoryAxis'
import ChartArea from '../KendoChartBase/ChartArea'
import Legend from '../KendoChartBase/Legend'
import Panes from '../KendoChartBase/Panes'
import Pannable from '../KendoChartBase/Pannable'
import Pdf from '../KendoChartBase/Pdf'
import PlotArea from '../KendoChartBase/PlotArea'
import Series from '../KendoChartBase/Series'
import SeriesDefaults from '../KendoChartBase/SeriesDefaults'
import Title from '../KendoChartBase/Title'
import Tooltip from '../KendoChartBase/Tooltip'
import ValueAxis from '../KendoChartBase/ValueAxis'
import XAxis from '../KendoChartBase/XAxis'
import YAxis from '../KendoChartBase/YAxis'
import Zoomable from '../KendoChartBase/Zoomable'
import { KendoBaseComponent, 
    KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'

import Navigator from './Navigator'

export default {
    props: StockChartProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoChartBase,
        Navigator,
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        AxisDefaults,
        CategoryAxis,
        ChartArea,
        Legend,
        Panes,
        Pannable,
        Pdf,
        PlotArea,
        Series,
        SeriesDefaults,
        Title,
        Tooltip,
        ValueAxis,
        XAxis,
        YAxis,
        Zoomable
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoStockChart(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget: function() {
            return kendo.jQuery(this.$el).getKendoStockChart()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoStockChart/KendoStockChartMixin.js